import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import Accordion from "../../Componentes/Accordion";
import { Questions } from "./Questions";
import PreguntasFrecuentesStyle from "Contents/PreguntasFrecuentes/style.module.scss";

const PreguntasFrecuentes: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-4'>
      <div className='text-center'>
        <div
          className={`${PreguntasFrecuentesStyle.titulo}`}
          data-testid='title'>
          <h1>Preguntas frecuentes!</h1>
        </div>
      </div>
      <div className='text-center' data-testid='textcenter'>
        <Accordion questions={Questions} />
      </div>
    </Container>
  );
};

export default new Content({
  Component: PreguntasFrecuentes,
  title: "Preguntas Frecuentes",
  route: "PreguntasFrecuentes",
  tags: ["PreguntasFrecuentes"]
});
